var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import dhbrown from '../../../../images/icons/dhbrown.svg';
import TextModule from './modules/textblock';
import ButtonModule from './modules/buttonblock';
import TitleModule from './modules/titlemodule';
import ItemsModule from './modules/itemsblock';
import CoaImage from './modules/imageblock';
import CoaText from './modules/coatext';
import CityItemsModule from './modules/cityitemsblock';
import MoreModule from './modules/moreblock';
import { SmartPostColorFull } from './modules/TypographySpecblocks/SmartPostColorFull';
import { SmartPostWithIcons } from './modules/TypographySpecblocks/SmartPostWithIcons';
import { LayoutConst } from '../../../../core/modules/layout.module';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding-left: 0px;\n  padding-right: 0px;\n  transform: ", ";\n  transform-origin: ", ";\n  right: ", ";\n  top: ", ";\n  box-shadow: none;\n  z-index: ", ";\n\n  .guttet-24 {\n    .col-xl-6,\n    .col-lg-6 {\n      padding-left: 12px;\n      padding-right: 12px;\n    }\n  }\n\n  .post_full_colored_style {\n    padding: 0 0 0 14px;\n  }\n\n  .post_with_icons_style {\n    padding: 0 0 0 14px;\n  }\n"], ["\n  position: relative;\n  padding-left: 0px;\n  padding-right: 0px;\n  transform: ", ";\n  transform-origin: ", ";\n  right: ", ";\n  top: ", ";\n  box-shadow: none;\n  z-index: ", ";\n\n  .guttet-24 {\n    .col-xl-6,\n    .col-lg-6 {\n      padding-left: 12px;\n      padding-right: 12px;\n    }\n  }\n\n  .post_full_colored_style {\n    padding: 0 0 0 14px;\n  }\n\n  .post_with_icons_style {\n    padding: 0 0 0 14px;\n  }\n"])), function (props) {
    return props.isDragging ? 'scale(0.4) rotate(10deg)' : 'scale(1)';
}, function (props) { return (props.isDragging ? 'left top' : 'center'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '2' : '4'); });
var TextItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 25px;\n  line-height: 40px;\n  color: #151514;\n  padding-top: ", ";\n  position: relative;\n  padding-left: ", ";\n  padding-right: ", ";\n  // padding-bottom: 36px;\n  border: ", ";\n  @media (max-width: ", "px) {\n    padding: 10px 0px;\n    margin-bottom: 16px;\n  }\n\n"], ["\n  background: ", ";\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 25px;\n  line-height: 40px;\n  color: #151514;\n  padding-top: ", ";\n  position: relative;\n  padding-left: ", ";\n  padding-right: ", ";\n  // padding-bottom: 36px;\n  border: ", ";\n  @media (max-width: ", "px) {\n    padding: 10px 0px;\n    margin-bottom: 16px;\n  }\n\n"])), function (p) { return [
    'readmoreblock',
    'postFullColored',
    'postWithIcons'
].includes(p.type)
    ? 'inherit'
    : p.hasButton
        ? '#1F1F1F'
        : '#FFFFFF'; }, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.colorStyle === 'light' ? '1px solid rgba(0,0,0,0.3)' : 'none';
}, LayoutConst.screen.s);
var TitleDrag = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  width: 14px;\n  height: 23px;\n  cursor: move;\n  top: 16px;\n  left: 16px;\n  background: url(", ") no-repeat center;\n  z-index: 9;\n  transition: 0.2s;\n  opacity: 0.31;\n\n  &:hover {\n    opacity: 1;\n  }\n"], ["\n  position: absolute;\n  width: 14px;\n  height: 23px;\n  cursor: move;\n  top: 16px;\n  left: 16px;\n  background: url(", ") no-repeat center;\n  z-index: 9;\n  transition: 0.2s;\n  opacity: 0.31;\n\n  &:hover {\n    opacity: 1;\n  }\n"])), dhbrown);
var RegBlock = function (props) {
    var blockEls = props.blockEls, type = props.type, isDragging = props.isDragging, dragHandleProps = props.dragHandleProps, colorStyle = props.colorStyle;
    var filteredTitle = blockEls.filter(function (item) { return item.typeElement === 'Title'; });
    var hasButton = blockEls.find(function (item) { var _a; return ((_a = item.typeElement) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "button"; });
    var modulesGen = useMemo(function () {
        var defaultBlock = blockEls.map(function (item, i) {
            if (item.typeElement === 'Text') {
                return React.createElement(TextModule, { key: i, textParameters: item.text, hasButton: hasButton });
            }
            // if (item.typeElement === 'Button') {
            //     return <ButtonModule key={i} textParameters={item.text} />
            // }
            if (item.typeElement === 'items') {
                return React.createElement(ItemsModule, __assign({ key: i, items: item.items, hasButton: hasButton }, props));
            }
            if (item.typeElement === 'Image') {
                return React.createElement(CoaImage, { key: i, imageSrc: item.image.urlImage });
            }
            if (item.typeElement === 'TextBigBold') {
                return React.createElement(CoaText, __assign({ key: i, name: item.text.textObject.name, hasButton: hasButton }, props));
            }
            if (item.typeElement === 'cityitems') {
                return React.createElement(CityItemsModule, __assign({ key: i, items: item.items, hasButton: hasButton }, props));
            }
            if (item.typeElement === 'readmoreitems') {
                return React.createElement(MoreModule, { key: i, items: item.items });
            }
            if (item.typeElement === 'postFullColored') {
                return React.createElement(SmartPostColorFull, { key: i, items: item.items });
            }
            if (item.typeElement === 'postWithIcons') {
                return (React.createElement(SmartPostWithIcons, { key: i, items: item.items, title: item.text.textObject.name }));
            }
        });
        var buttonElement = hasButton
            ? [
                React.createElement(ButtonModule, __assign({ key: 'hasButton', textParameters: hasButton.text }, props, { isButton: true }))
            ]
            : [];
        return __spreadArray(__spreadArray([], defaultBlock, true), [buttonElement], false);
    }, [blockEls, hasButton]);
    var moduleTitle = filteredTitle.map(function (item, i) {
        return React.createElement(TitleModule, { key: i, textParameters: item.text });
    });
    useEffect(function () { }, []);
    return (React.createElement(Wrap, { isDragging: isDragging, className: "spec-reg-block-container".concat(hasButton ? '-button' : '') },
        filteredTitle.length > 0 ? moduleTitle : '',
        React.createElement(TextItem, { colorStyle: colorStyle, type: type, hasButton: hasButton, className: "spec-text-item".concat(hasButton ? '-button' : '') },
            React.createElement("div", { className: "row spec-reg-block-wrapper".concat(hasButton ? '-button' : '', "\n                        ").concat(type === 'coa' ? 'align-items-center' : '', "\n                        ").concat(type === 'readmoreblock' ? 'guttet-24' : '', "\n                        ").concat(type === 'postFullColored'
                    ? 'post_full_colored_style'
                    : '', "\n                        ").concat(type === 'postWithIcons'
                    ? 'post_with_icons_style'
                    : '', "\n                    ") }, modulesGen),
            React.createElement(TitleDrag, __assign({}, dragHandleProps, { className: 'handle__toogle spec-title-drag' })))));
};
export default RegBlock;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=regblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import dhbrown from '../../../../images/icons/dhbrown.svg';
import TextModule from './modules/textblock';
import ButtonModule from './modules/buttonblock';
import TitleModule from './modules/titlemodule';
import ItemsModule from './modules/itemsblock';
import CoaImage from './modules/imageblock';
import CoaText from './modules/coatext';
import CityItemsModule from './modules/cityitemsblock';
import MoreModule from './modules/moreblock';
import { SmartPostColorFull } from './modules/TypographySpecblocks/SmartPostColorFull';
import { SmartPostWithIcons } from './modules/TypographySpecblocks/SmartPostWithIcons';
import { LayoutConst } from '../../../../core/modules/layout.module';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding-left: 0px;\n  padding-right: 0px;\n  transform: ", ";\n  transform-origin: ", ";\n  right: ", ";\n  top: ", ";\n  box-shadow: none;\n  z-index: ", ";\n\n  .guttet-24 {\n    .col-xl-6,\n    .col-lg-6 {\n      padding-left: 12px;\n      padding-right: 12px;\n    }\n  }\n\n  .post_full_colored_style {\n    padding: 0 0 0 14px;\n  }\n\n  .post_with_icons_style {\n    padding: 0 0 0 14px;\n  }\n"], ["\n  position: relative;\n  padding-left: 0px;\n  padding-right: 0px;\n  transform: ", ";\n  transform-origin: ", ";\n  right: ", ";\n  top: ", ";\n  box-shadow: none;\n  z-index: ", ";\n\n  .guttet-24 {\n    .col-xl-6,\n    .col-lg-6 {\n      padding-left: 12px;\n      padding-right: 12px;\n    }\n  }\n\n  .post_full_colored_style {\n    padding: 0 0 0 14px;\n  }\n\n  .post_with_icons_style {\n    padding: 0 0 0 14px;\n  }\n"])), function (props) {
    return props.isDragging ? 'scale(0.4) rotate(10deg)' : 'scale(1)';
}, function (props) { return (props.isDragging ? 'left top' : 'center'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '2' : '4'); });
var TextItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 25px;\n  line-height: 40px;\n  color: #151514;\n  padding-top: ", ";\n  position: relative;\n  padding-left: ", ";\n  padding-right: ", ";\n  // padding-bottom: 36px;\n  border: ", ";\n  @media (max-width: ", "px) {\n    padding: 10px 0px;\n    margin-bottom: 16px;\n  }\n\n"], ["\n  background: ", ";\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 25px;\n  line-height: 40px;\n  color: #151514;\n  padding-top: ", ";\n  position: relative;\n  padding-left: ", ";\n  padding-right: ", ";\n  // padding-bottom: 36px;\n  border: ", ";\n  @media (max-width: ", "px) {\n    padding: 10px 0px;\n    margin-bottom: 16px;\n  }\n\n"])), function (p) { return [
    'readmoreblock',
    'postFullColored',
    'postWithIcons'
].includes(p.type)
    ? 'inherit'
    : p.hasButton
        ? '#1F1F1F'
        : '#FFFFFF'; }, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.colorStyle === 'light' ? '1px solid rgba(0,0,0,0.3)' : 'none';
}, LayoutConst.screen.s);
var TitleDrag = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  width: 14px;\n  height: 23px;\n  cursor: move;\n  top: 16px;\n  left: 16px;\n  background: url(", ") no-repeat center;\n  z-index: 9;\n  transition: 0.2s;\n  opacity: 0.31;\n\n  &:hover {\n    opacity: 1;\n  }\n"], ["\n  position: absolute;\n  width: 14px;\n  height: 23px;\n  cursor: move;\n  top: 16px;\n  left: 16px;\n  background: url(", ") no-repeat center;\n  z-index: 9;\n  transition: 0.2s;\n  opacity: 0.31;\n\n  &:hover {\n    opacity: 1;\n  }\n"])), dhbrown);
var RegBlock = function (props) {
    var blockEls = props.blockEls, type = props.type, isDragging = props.isDragging, dragHandleProps = props.dragHandleProps, colorStyle = props.colorStyle;
    var filteredTitle = blockEls.filter(function (item) { return item.typeElement === 'Title'; });
    var hasButton = blockEls.find(function (item) { var _a; return ((_a = item.typeElement) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "button"; });
    var modulesGen = useMemo(function () {
        var defaultBlock = blockEls.map(function (item, i) {
            if (item.typeElement === 'Text') {
                return React.createElement(TextModule, { key: i, textParameters: item.text, hasButton: hasButton });
            }
            // if (item.typeElement === 'Button') {
            //     return <ButtonModule key={i} textParameters={item.text} />
            // }
            if (item.typeElement === 'items') {
                return React.createElement(ItemsModule, __assign({ key: i, items: item.items, hasButton: hasButton }, props));
            }
            if (item.typeElement === 'Image') {
                return React.createElement(CoaImage, { key: i, imageSrc: item.image.urlImage });
            }
            if (item.typeElement === 'TextBigBold') {
                return React.createElement(CoaText, __assign({ key: i, name: item.text.textObject.name, hasButton: hasButton }, props));
            }
            if (item.typeElement === 'cityitems') {
                return React.createElement(CityItemsModule, __assign({ key: i, items: item.items, hasButton: hasButton }, props));
            }
            if (item.typeElement === 'readmoreitems') {
                return React.createElement(MoreModule, { key: i, items: item.items });
            }
            if (item.typeElement === 'postFullColored') {
                return React.createElement(SmartPostColorFull, { key: i, items: item.items });
            }
            if (item.typeElement === 'postWithIcons') {
                return (React.createElement(SmartPostWithIcons, { key: i, items: item.items, title: item.text.textObject.name }));
            }
        });
        var buttonElement = hasButton
            ? [
                React.createElement(ButtonModule, __assign({ key: 'hasButton', textParameters: hasButton.text }, props, { isButton: true }))
            ]
            : [];
        return __spreadArray(__spreadArray([], defaultBlock, true), [buttonElement], false);
    }, [blockEls, hasButton]);
    var moduleTitle = filteredTitle.map(function (item, i) {
        return React.createElement(TitleModule, { key: i, textParameters: item.text });
    });
    useEffect(function () { }, []);
    return (React.createElement(Wrap, { isDragging: isDragging, className: "spec-reg-block-container".concat(hasButton ? '-button' : '') },
        filteredTitle.length > 0 ? moduleTitle : '',
        React.createElement(TextItem, { colorStyle: colorStyle, type: type, hasButton: hasButton, className: "spec-text-item".concat(hasButton ? '-button' : '') },
            React.createElement("div", { className: "row spec-reg-block-wrapper".concat(hasButton ? '-button' : '', "\n                        ").concat(type === 'coa' ? 'align-items-center' : '', "\n                        ").concat(type === 'readmoreblock' ? 'guttet-24' : '', "\n                        ").concat(type === 'postFullColored'
                    ? 'post_full_colored_style'
                    : '', "\n                        ").concat(type === 'postWithIcons'
                    ? 'post_with_icons_style'
                    : '', "\n                    ") }, modulesGen),
            React.createElement(TitleDrag, __assign({}, dragHandleProps, { className: 'handle__toogle spec-title-drag' })))));
};
export default RegBlock;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=regblock.js.map